var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g, _g2, _g3, _g4, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _circle, _path54, _path55, _path56, _circle2, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWishImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    width: 937.26,
    height: 810.26,
    viewBox: "0 0 937.26 810.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "7be86fb0-21fd-45a4-8a23-e3ab7af79f8b-114",
    x1: 518.1,
    y1: 814,
    x2: 518.1,
    y2: 264.36,
    gradientTransform: "matrix(-1, 0, 0, 1, 1200, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wishes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1014.66,421.52c-31.82,40.46-19.46,99.57.76,146.9C1022.2,584.27,1029.85,601,1027,618c-3.49,20.78-22,36-41.52,44-35.5,14.68-78,11.18-110.61-9.11-28.19-17.54-48.38-46.06-77.05-62.8-48-28-109.06-17.43-161.16,1.86-36.86,13.65-77.16,31.41-113.79,17.14-25.77-10-43.59-34.47-53.3-60.37-4.69-12.51-8.09-26-17-36-5.32-5.89-12.26-10.08-19.38-13.6-65-32.21-147-15-210.08-50.68-42.61-24.12-69.89-69.63-82-117.08s-10.67-97.21-7.6-146.07c2.18-34.73,6.09-71.8,28.28-98.61C185.25,58.44,225.54,47.9,262,53.29s69.42,24.6,98.45,47.22c36.29,28.27,69.94,63.48,114.5,74.94,30.34,7.8,62.26,3.53,93.56,2.06,52.32-2.47,104.65,3,156.68,9,49.81,5.76,100,12.1,147.43,28.3,33.58,11.47,60.5,32.28,92.21,46.82,20.67,9.48,43.21,12.1,62.77,24.17,24.11,14.87,46.2,40.74,40,71C1061.71,385.61,1031.56,400,1014.66,421.52Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.31,752.58c7.12,3.67,14.58,6.84,21.94,10,27.19,11.48,54.79,23.06,84,27,54.82,7.39,111.44-12.62,165.33-.17,45.15,10.42,82.49,42.35,126.6,56.57,20.51,6.61,41.85,9.2,63.38,9.2h2.78q4-.05,7.94-.2c21.83-.82,43.75-4.05,65.15-8.18,67.57-13,136.34-36.83,188-80.7C780.05,738.57,470.2,696.39,205.31,752.58Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M242.15,749.65s24.67-83.76-4.63-145.41c-12.3-25.87-16.38-54.92-10.7-83a222.5,222.5,0,0,1,11.75-39",
    transform: "translate(-131.37 -44.87)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.35,443.33c0,10.27,18.59,40,18.59,40s18.59-29.77,18.59-40a18.59,18.59,0,0,0-37.17,0Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M189.62,500.19c5.58,8.62,37.36,23.5,37.36,23.5s-.58-35.09-6.16-43.71a18.59,18.59,0,1,0-31.2,20.2Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M191,597.36c9.17,4.62,44.11,1.43,44.11,1.43s-18.21-30-27.38-34.62A18.59,18.59,0,1,0,191,597.36Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M208.54,670.65c8.25,6.1,43.24,8.86,43.24,8.86s-12.88-32.64-21.13-38.75a18.59,18.59,0,0,0-22.11,29.89Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M266,525.68c-7.36,7.15-41.67,14.56-41.67,14.56s8.4-34.07,15.76-41.23A18.59,18.59,0,0,1,266,525.68Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M285.47,611.66c-9.17,4.62-44.11,1.43-44.11,1.43s18.21-30,27.38-34.62a18.59,18.59,0,0,1,16.74,33.19Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M292.92,697.81c-8.25,6.1-43.24,8.86-43.24,8.86s12.88-32.64,21.13-38.75a18.59,18.59,0,0,1,22.11,29.89Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M220.35,443.33c0,10.27,18.59,40,18.59,40s18.59-29.77,18.59-40a18.59,18.59,0,0,0-37.17,0Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.25
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M189.62,500.19c5.58,8.62,37.36,23.5,37.36,23.5s-.58-35.09-6.16-43.71a18.59,18.59,0,1,0-31.2,20.2Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.25
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M191,597.36c9.17,4.62,44.11,1.43,44.11,1.43s-18.21-30-27.38-34.62A18.59,18.59,0,1,0,191,597.36Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.25
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M208.54,670.65c8.25,6.1,43.24,8.86,43.24,8.86s-12.88-32.64-21.13-38.75a18.59,18.59,0,0,0-22.11,29.89Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.25
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M266,525.68c-7.36,7.15-41.67,14.56-41.67,14.56s8.4-34.07,15.76-41.23A18.59,18.59,0,0,1,266,525.68Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.25
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M285.47,611.66c-9.17,4.62-44.11,1.43-44.11,1.43s18.21-30,27.38-34.62a18.59,18.59,0,0,1,16.74,33.19Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.25
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M292.92,697.81c-8.25,6.1-43.24,8.86-43.24,8.86s12.88-32.64,21.13-38.75a18.59,18.59,0,0,1,22.11,29.89Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.25
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M369.44,724.14s13.36-45.35-2.5-78.72a71.62,71.62,0,0,1-5.79-44.93,120.46,120.46,0,0,1,6.36-21.09",
    transform: "translate(-131.37 -44.87)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M357.64,558.3c0,5.56,10.06,21.67,10.06,21.67s10.06-16.12,10.06-21.67a10.06,10.06,0,0,0-20.13,0Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M341,589.08c3,4.66,20.23,12.72,20.23,12.72s-.31-19-3.33-23.66A10.06,10.06,0,0,0,341,589.08Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M341.73,641.69c5,2.5,23.88.77,23.88.77s-9.86-16.24-14.82-18.74a10.06,10.06,0,1,0-9.06,18Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M351.24,681.37c4.47,3.3,23.41,4.8,23.41,4.8s-7-17.67-11.44-21a10.06,10.06,0,1,0-12,16.18Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M382.36,602.88c-4,3.87-22.56,7.88-22.56,7.88s4.55-18.45,8.53-22.32a10.06,10.06,0,1,1,14,14.44Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M392.89,649.43c-5,2.5-23.88.77-23.88.77s9.86-16.24,14.82-18.74a10.06,10.06,0,1,1,9.06,18Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M396.93,696.07c-4.47,3.3-23.41,4.8-23.41,4.8s7-17.67,11.44-21a10.06,10.06,0,0,1,12,16.18Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M357.64,558.3c0,5.56,10.06,21.67,10.06,21.67s10.06-16.12,10.06-21.67a10.06,10.06,0,0,0-20.13,0Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#fff",
    opacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M341,589.08c3,4.66,20.23,12.72,20.23,12.72s-.31-19-3.33-23.66A10.06,10.06,0,0,0,341,589.08Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#fff",
    opacity: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M341.73,641.69c5,2.5,23.88.77,23.88.77s-9.86-16.24-14.82-18.74a10.06,10.06,0,1,0-9.06,18Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#fff",
    opacity: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M351.24,681.37c4.47,3.3,23.41,4.8,23.41,4.8s-7-17.67-11.44-21a10.06,10.06,0,1,0-12,16.18Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#fff",
    opacity: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M382.36,602.88c-4,3.87-22.56,7.88-22.56,7.88s4.55-18.45,8.53-22.32a10.06,10.06,0,1,1,14,14.44Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#fff",
    opacity: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M392.89,649.43c-5,2.5-23.88.77-23.88.77s9.86-16.24,14.82-18.74a10.06,10.06,0,1,1,9.06,18Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#fff",
    opacity: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M396.93,696.07c-4.47,3.3-23.41,4.8-23.41,4.8s7-17.67,11.44-21a10.06,10.06,0,0,1,12,16.18Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#fff",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.66,99.13a11.69,11.69,0,0,0-4.21,10.29c1.37,12.72,5.49,41.65,15.76,57.94q.91,1.45,1.9,2.77h55.51s11.32-42.11,12.07-60.67a14,14,0,0,0-5-11.3c-8.32-6.91-27.85-22-38.93-21l-.22,0S373.28,72.39,340.66,99.13Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#d6dbe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.45,109.42c1.37,12.72,5.49,41.65,15.76,57.94,2.21,1,4.47,1.89,6.71,2.77,14,5.47,27.23,8.7,25.09,0a19.68,19.68,0,0,0-2.14-4.89c-12.73-22.15-6.84-70.45-4.14-88l-.22,0s-4.22-4.82-36.84,21.92A11.69,11.69,0,0,0,336.45,109.42Z",
    transform: "translate(-131.37 -44.87)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.45,109.42c1.37,12.72,5.49,41.65,15.76,57.94,2.21,1,4.47,1.89,6.71,2.77,14,5.47,27.23,8.7,25.09,0a19.68,19.68,0,0,0-2.14-4.89c-12.73-22.15-6.84-70.45-4.14-88l-.22,0s-4.22-4.82-36.84,21.92A11.69,11.69,0,0,0,336.45,109.42Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.77,168.64c0,2.44,2.08,4.69,5.59,6.51a34.32,34.32,0,0,0,7.55,2.7,64.06,64.06,0,0,0,15,1.67,60.14,60.14,0,0,0,17.93-2.5,25.17,25.17,0,0,0,6.7-3.14c2.2-1.55,3.46-3.33,3.46-5.23,0-2.77-2.67-5.29-7.06-7.21q-1.06-.47-2.26-.88a58.83,58.83,0,0,0-18.76-2.78c-8.92,0-16.86,1.61-22,4.12a19.34,19.34,0,0,0-2.49,1.44C355.08,164.9,353.77,166.71,353.77,168.64Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#d6dbe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.18,168.64c0,2.44,2.08,4.69,5.59,6.51a34.32,34.32,0,0,0,7.55,2.7,64.06,64.06,0,0,0,15,1.67,60.14,60.14,0,0,0,17.93-2.5,25.17,25.17,0,0,0,6.7-3.14c2.2-1.55,3.46-3.33,3.46-5.23,0-2.77-2.67-5.29-7.06-7.21q-1.06-.47-2.26-.88a58.83,58.83,0,0,0-18.76-2.78c-8.92,0-16.86,1.61-22,4.12a19.34,19.34,0,0,0-2.49,1.44C354.48,164.9,353.18,166.71,353.18,168.64Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.23,171.6a7.26,7.26,0,0,0-1.93-9.26s-1.92-2.31-.74-4.41c0,0-9.81,6.48-4.81,13.93Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#ffd865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.84,171.82a3.27,3.27,0,0,0-.87-4.17,2,2,0,0,1-.33-2s-4.42,2.92-2.16,6.27Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#ffd865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.84,171.82a3.27,3.27,0,0,0-.87-4.17,2,2,0,0,1-.33-2s-4.42,2.92-2.16,6.27Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.36,175.15a34.32,34.32,0,0,0,7.55,2.7c8-1.86,31-7.84,36-16.41q-1.06-.47-2.26-.88C397.41,164.31,384.4,177.3,359.36,175.15Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#565387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.36,163.32c3,5.41,31,11.44,42.43,13.69a25.17,25.17,0,0,0,6.7-3.14,101.8,101.8,0,0,1-46.64-12A19.34,19.34,0,0,0,357.36,163.32Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#565387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,98.69c1.65,1.62,1.19,4.3,1,6.6a19.72,19.72,0,0,0,3.13,12.21c1.46,2.23,3.47,4.51,3.11,7.15s-3.11,4.41-4.57,6.74-1.58,5.45-1.15,8.26,1.3,5.55,1.52,8.38a3.78,3.78,0,0,1-.21,1.92,5.21,5.21,0,0,1-1.39,1.52,10.76,10.76,0,0,0-2.29,2.9,7.19,7.19,0,0,1-1.16,1.84,4.46,4.46,0,0,1-1.4.85c-3.75,1.58-8.07,1.3-11.94.06a51.7,51.7,0,0,1-10.86-5.48,8.88,8.88,0,0,1-2.54-2,7.27,7.27,0,0,1-1.22-4.11c-.16-3.13.43-6.28.06-9.4s-1.82-6.26-2.71-9.4a29.54,29.54,0,0,1,.7-18.2,13.64,13.64,0,0,1,4.18-6.3c4.36-3.32,10.7-2,15.75-4.11C384.79,96.52,389.54,95.28,393,98.69Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#ffd865",
    opacity: 0.35
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.85,249.39a6.76,6.76,0,0,0-2.44,5.95c.79,7.35,3.17,24.08,9.11,33.5q.53.84,1.1,1.6h32.09s6.54-24.34,7-35.07a8.07,8.07,0,0,0-2.91-6.53c-4.81-4-16.1-12.7-22.5-12.12h-.13S273.71,233.93,254.85,249.39Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#d6dbe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.42,255.34c.79,7.35,3.17,24.08,9.11,33.5,1.28.55,2.58,1.09,3.88,1.6,8.07,3.16,15.74,5,14.5,0a11.37,11.37,0,0,0-1.24-2.83c-7.36-12.8-4-40.72-2.39-50.9h-.13s-2.44-2.79-21.29,12.67A6.76,6.76,0,0,0,252.42,255.34Z",
    transform: "translate(-131.37 -44.87)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.42,255.34c.79,7.35,3.17,24.08,9.11,33.5,1.28.55,2.58,1.09,3.88,1.6,8.07,3.16,15.74,5,14.5,0a11.37,11.37,0,0,0-1.24-2.83c-7.36-12.8-4-40.72-2.39-50.9h-.13s-2.44-2.79-21.29,12.67A6.76,6.76,0,0,0,252.42,255.34Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.43,289.57c0,1.41,1.2,2.71,3.23,3.76a19.84,19.84,0,0,0,4.36,1.56,37,37,0,0,0,8.64,1A34.76,34.76,0,0,0,289,294.41a14.55,14.55,0,0,0,3.88-1.82,3.91,3.91,0,0,0,2-3c0-1.6-1.54-3.06-4.08-4.17q-.62-.27-1.31-.51a34,34,0,0,0-10.85-1.61c-5.15,0-9.75.93-12.72,2.38a11.18,11.18,0,0,0-1.44.83A4,4,0,0,0,262.43,289.57Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#d6dbe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.09,289.57c0,1.41,1.2,2.71,3.23,3.76a19.84,19.84,0,0,0,4.36,1.56,37,37,0,0,0,8.64,1,34.76,34.76,0,0,0,10.36-1.45,14.55,14.55,0,0,0,3.88-1.82,3.91,3.91,0,0,0,2-3c0-1.6-1.54-3.06-4.08-4.17q-.62-.27-1.31-.51a34,34,0,0,0-10.85-1.61c-5.15,0-9.75.93-12.72,2.38a11.18,11.18,0,0,0-1.44.83A4,4,0,0,0,262.09,289.57Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.78,291.28a4.19,4.19,0,0,0-1.11-5.35,2.5,2.5,0,0,1-.43-2.55s-5.67,3.75-2.78,8.05Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#ffd865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.39,291.41a1.89,1.89,0,0,0-.5-2.41,1.13,1.13,0,0,1-.19-1.15s-2.55,1.69-1.25,3.62Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#ffd865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.39,291.41a1.89,1.89,0,0,0-.5-2.41,1.13,1.13,0,0,1-.19-1.15s-2.55,1.69-1.25,3.62Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.66,293.34a19.84,19.84,0,0,0,4.36,1.56c4.63-1.07,17.91-4.53,20.8-9.49q-.62-.27-1.31-.51C287.66,287.07,280.14,294.58,265.66,293.34Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#565387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.51,286.5c1.73,3.13,17.93,6.61,24.53,7.91a14.55,14.55,0,0,0,3.88-1.82,58.84,58.84,0,0,1-27-6.93A11.18,11.18,0,0,0,264.51,286.5Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#565387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.12,249.14c1,.93.69,2.49.58,3.82a11.4,11.4,0,0,0,1.81,7.06c.84,1.29,2,2.61,1.8,4.13s-1.8,2.55-2.64,3.9a7,7,0,0,0-.67,4.77c.25,1.62.75,3.21.88,4.84a2.18,2.18,0,0,1-.12,1.11,3,3,0,0,1-.8.88,6.22,6.22,0,0,0-1.32,1.68,4.16,4.16,0,0,1-.67,1.06,2.58,2.58,0,0,1-.81.49,10,10,0,0,1-6.9,0,29.88,29.88,0,0,1-6.28-3.17,5.13,5.13,0,0,1-1.47-1.16,4.2,4.2,0,0,1-.71-2.37c-.09-1.81.25-3.63,0-5.43a36.27,36.27,0,0,0-1.57-5.44,17.07,17.07,0,0,1,.41-10.52,7.89,7.89,0,0,1,2.42-3.64c2.52-1.92,6.19-1.14,9.11-2.38C280.36,247.89,283.11,247.17,285.12,249.14Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#ffd865",
    opacity: 0.35
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M764.85,230.09a6.76,6.76,0,0,0-2.44,5.95c.79,7.35,3.17,24.08,9.11,33.5q.53.84,1.1,1.6h32.09s6.54-24.34,7-35.07a8.07,8.07,0,0,0-2.91-6.53c-4.81-4-16.1-12.7-22.5-12.12h-.13S783.71,214.63,764.85,230.09Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#d6dbe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.42,236c.79,7.35,3.17,24.08,9.11,33.5,1.28.55,2.58,1.09,3.88,1.6,8.07,3.16,15.74,5,14.5,0a11.37,11.37,0,0,0-1.24-2.83c-7.36-12.8-4-40.72-2.39-50.9h-.13s-2.44-2.79-21.29,12.67A6.76,6.76,0,0,0,762.42,236Z",
    transform: "translate(-131.37 -44.87)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.42,236c.79,7.35,3.17,24.08,9.11,33.5,1.28.55,2.58,1.09,3.88,1.6,8.07,3.16,15.74,5,14.5,0a11.37,11.37,0,0,0-1.24-2.83c-7.36-12.8-4-40.72-2.39-50.9h-.13s-2.44-2.79-21.29,12.67A6.76,6.76,0,0,0,762.42,236Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.43,270.27c0,1.41,1.2,2.71,3.23,3.76a19.84,19.84,0,0,0,4.36,1.56,37,37,0,0,0,8.64,1A34.76,34.76,0,0,0,799,275.11a14.55,14.55,0,0,0,3.88-1.82,3.91,3.91,0,0,0,2-3c0-1.6-1.54-3.06-4.08-4.17q-.62-.27-1.31-.51A34,34,0,0,0,788.67,264c-5.15,0-9.75.93-12.72,2.38a11.18,11.18,0,0,0-1.44.83A4,4,0,0,0,772.43,270.27Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#d6dbe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.09,270.27c0,1.41,1.2,2.71,3.23,3.76a19.84,19.84,0,0,0,4.36,1.56,37,37,0,0,0,8.64,1,34.76,34.76,0,0,0,10.36-1.45,14.55,14.55,0,0,0,3.88-1.82,3.91,3.91,0,0,0,2-3c0-1.6-1.54-3.06-4.08-4.17q-.62-.27-1.31-.51A34,34,0,0,0,788.33,264c-5.15,0-9.75.93-12.72,2.38a11.18,11.18,0,0,0-1.44.83A4,4,0,0,0,772.09,270.27Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.78,272a4.19,4.19,0,0,0-1.11-5.35,2.5,2.5,0,0,1-.43-2.55s-5.67,3.75-2.78,8.05Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#ffd865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.39,272.11a1.89,1.89,0,0,0-.5-2.41,1.13,1.13,0,0,1-.19-1.15s-2.55,1.69-1.25,3.62Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#ffd865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.39,272.11a1.89,1.89,0,0,0-.5-2.41,1.13,1.13,0,0,1-.19-1.15s-2.55,1.69-1.25,3.62Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.66,274a19.84,19.84,0,0,0,4.36,1.56c4.63-1.07,17.91-4.53,20.8-9.49q-.62-.27-1.31-.51C797.66,267.77,790.14,275.27,775.66,274Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#565387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.51,267.19c1.73,3.13,17.93,6.61,24.53,7.91a14.55,14.55,0,0,0,3.88-1.82,58.84,58.84,0,0,1-27-6.93A11.18,11.18,0,0,0,774.51,267.19Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#565387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.12,229.83c1,.93.69,2.49.58,3.82a11.4,11.4,0,0,0,1.81,7.06c.84,1.29,2,2.61,1.8,4.13s-1.8,2.55-2.64,3.9a7,7,0,0,0-.67,4.77c.25,1.62.75,3.21.88,4.84a2.18,2.18,0,0,1-.12,1.11,3,3,0,0,1-.8.88,6.22,6.22,0,0,0-1.32,1.68,4.16,4.16,0,0,1-.67,1.06,2.58,2.58,0,0,1-.81.49,10,10,0,0,1-6.9,0,29.88,29.88,0,0,1-6.28-3.17,5.13,5.13,0,0,1-1.47-1.16,4.2,4.2,0,0,1-.71-2.37c-.09-1.81.25-3.63,0-5.43a36.27,36.27,0,0,0-1.57-5.44,17.07,17.07,0,0,1,.41-10.52,7.89,7.89,0,0,1,2.42-3.64c2.52-1.92,6.19-1.14,9.11-2.38C790.36,228.58,793.11,227.86,795.12,229.83Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#ffd865",
    opacity: 0.35
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M853.66,67.13a11.69,11.69,0,0,0-4.21,10.29c1.37,12.72,5.49,41.65,15.76,57.94q.91,1.45,1.9,2.77h55.51S933.94,96,934.69,77.46a14,14,0,0,0-5-11.3c-8.32-6.91-27.85-22-38.93-21l-.22,0S886.28,40.39,853.66,67.13Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#d6dbe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.45,77.42c1.37,12.72,5.49,41.65,15.76,57.94,2.21,1,4.47,1.89,6.71,2.77,14,5.47,27.23,8.7,25.09,0a19.68,19.68,0,0,0-2.14-4.89c-12.73-22.15-6.84-70.45-4.14-88l-.22,0s-4.22-4.82-36.84,21.92A11.69,11.69,0,0,0,849.45,77.42Z",
    transform: "translate(-131.37 -44.87)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.45,77.42c1.37,12.72,5.49,41.65,15.76,57.94,2.21,1,4.47,1.89,6.71,2.77,14,5.47,27.23,8.7,25.09,0a19.68,19.68,0,0,0-2.14-4.89c-12.73-22.15-6.84-70.45-4.14-88l-.22,0s-4.22-4.82-36.84,21.92A11.69,11.69,0,0,0,849.45,77.42Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.77,136.64c0,2.44,2.08,4.69,5.59,6.51a34.32,34.32,0,0,0,7.55,2.7,64.06,64.06,0,0,0,15,1.67,60.14,60.14,0,0,0,17.93-2.5,25.17,25.17,0,0,0,6.7-3.14c2.2-1.55,3.46-3.33,3.46-5.23,0-2.77-2.67-5.29-7.06-7.21q-1.06-.47-2.26-.88a58.83,58.83,0,0,0-18.76-2.78c-8.92,0-16.86,1.61-22,4.12a19.34,19.34,0,0,0-2.49,1.44C868.08,132.9,866.77,134.71,866.77,136.64Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#d6dbe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.18,136.64c0,2.44,2.08,4.69,5.59,6.51a34.32,34.32,0,0,0,7.55,2.7,64.06,64.06,0,0,0,15,1.67,60.14,60.14,0,0,0,17.93-2.5,25.17,25.17,0,0,0,6.7-3.14c2.2-1.55,3.46-3.33,3.46-5.23,0-2.77-2.67-5.29-7.06-7.21q-1.06-.47-2.26-.88a58.83,58.83,0,0,0-18.76-2.78c-8.92,0-16.86,1.61-22,4.12a19.34,19.34,0,0,0-2.49,1.44C867.48,132.9,866.18,134.71,866.18,136.64Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.23,139.6a7.26,7.26,0,0,0-1.93-9.26s-1.92-2.31-.74-4.41c0,0-9.81,6.48-4.81,13.93Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#ffd865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.84,139.82a3.27,3.27,0,0,0-.87-4.17,2,2,0,0,1-.33-2s-4.42,2.92-2.16,6.27Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#ffd865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.84,139.82a3.27,3.27,0,0,0-.87-4.17,2,2,0,0,1-.33-2s-4.42,2.92-2.16,6.27Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.36,143.15a34.32,34.32,0,0,0,7.55,2.7c8-1.86,31-7.84,36-16.41q-1.06-.47-2.26-.88C910.41,132.31,897.4,145.3,872.36,143.15Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#565387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.36,131.32c3,5.41,31,11.44,42.43,13.69a25.17,25.17,0,0,0,6.7-3.14,101.8,101.8,0,0,1-46.64-12A19.34,19.34,0,0,0,870.36,131.32Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#565387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906,66.69c1.65,1.62,1.19,4.3,1,6.6a19.72,19.72,0,0,0,3.13,12.21c1.46,2.23,3.47,4.51,3.11,7.15s-3.11,4.41-4.57,6.74-1.58,5.45-1.15,8.26,1.3,5.55,1.52,8.38a3.78,3.78,0,0,1-.21,1.92,5.21,5.21,0,0,1-1.39,1.52,10.76,10.76,0,0,0-2.29,2.9,7.19,7.19,0,0,1-1.16,1.84,4.46,4.46,0,0,1-1.4.85c-3.75,1.58-8.07,1.3-11.94.06a51.7,51.7,0,0,1-10.86-5.48,8.88,8.88,0,0,1-2.54-2,7.27,7.27,0,0,1-1.22-4.11c-.16-3.13.43-6.28.06-9.4s-1.82-6.26-2.71-9.4a29.54,29.54,0,0,1,.7-18.2,13.64,13.64,0,0,1,4.18-6.3c4.36-3.32,10.7-2,15.75-4.11C897.79,64.52,902.54,63.28,906,66.69Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#ffd865",
    opacity: 0.35
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M571.57,148.86a19.64,19.64,0,0,0-7.08,17.29c2.3,21.37,9.21,70,26.47,97.33q1.54,2.44,3.19,4.64H687.4s19-70.74,20.28-101.91a23.45,23.45,0,0,0-8.46-19c-14-11.61-46.78-36.91-65.4-35.23l-.38,0S626.36,103.95,571.57,148.86Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#d6dbe6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M564.49,166.15c2.3,21.37,9.21,70,26.47,97.33,3.71,1.6,7.5,3.17,11.26,4.64,23.44,9.19,45.75,14.61,42.14,0a33.05,33.05,0,0,0-3.59-8.21c-21.39-37.2-11.5-118.33-7-147.9l-.38,0s-7.09-8.1-61.88,36.81A19.64,19.64,0,0,0,564.49,166.15Z",
    transform: "translate(-131.37 -44.87)",
    fill: "none"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M564.49,166.15c2.3,21.37,9.21,70,26.47,97.33,3.71,1.6,7.5,3.17,11.26,4.64,23.44,9.19,45.75,14.61,42.14,0a33.05,33.05,0,0,0-3.59-8.21c-21.39-37.2-11.5-118.33-7-147.9l-.38,0s-7.09-8.1-61.88,36.81A19.64,19.64,0,0,0,564.49,166.15Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.05
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M593.6,265.63c0,4.1,3.49,7.89,9.38,10.93a57.65,57.65,0,0,0,12.68,4.53,107.61,107.61,0,0,0,25.12,2.8c11.45,0,21.94-1.58,30.11-4.2a42.28,42.28,0,0,0,11.26-5.28c3.7-2.61,5.81-5.6,5.81-8.79,0-4.64-4.48-8.89-11.86-12.11q-1.79-.78-3.8-1.48c-8.35-2.91-19.4-4.67-31.52-4.67-15,0-28.33,2.7-37,6.92a32.49,32.49,0,0,0-4.19,2.41C595.78,259.34,593.6,262.39,593.6,265.63Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#d6dbe6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M592.6,265.63c0,4.1,3.49,7.89,9.38,10.93a57.65,57.65,0,0,0,12.68,4.53,107.61,107.61,0,0,0,25.12,2.8c11.45,0,21.94-1.58,30.11-4.2a42.28,42.28,0,0,0,11.26-5.28c3.7-2.61,5.81-5.6,5.81-8.79,0-4.64-4.48-8.89-11.86-12.11q-1.79-.78-3.8-1.48c-8.35-2.91-19.4-4.67-31.52-4.67-15,0-28.33,2.7-37,6.92a32.49,32.49,0,0,0-4.19,2.41C594.78,259.34,592.6,262.39,592.6,265.63Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M649.81,270.6s5.06-8.36-3.24-15.56c0,0-3.22-3.88-1.25-7.4,0,0-16.48,10.88-8.08,23.4Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#ffd865"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M645.79,271a5.49,5.49,0,0,0-1.46-7s-1.45-1.75-.56-3.33c0,0-7.42,4.9-3.64,10.53Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#ffd865"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M645.79,271a5.49,5.49,0,0,0-1.46-7s-1.45-1.75-.56-3.33c0,0-7.42,4.9-3.64,10.53Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M603,276.56a57.65,57.65,0,0,0,12.68,4.53c13.45-3.12,52-13.17,60.43-27.57q-1.79-.78-3.8-1.48C666.9,258.36,645,280.17,603,276.56Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#565387"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M599.62,256.7c5,9.09,52.09,19.21,71.27,23a42.28,42.28,0,0,0,11.26-5.28,171,171,0,0,1-78.34-20.13A32.49,32.49,0,0,0,599.62,256.7Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#565387"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M659.53,148.13c2.77,2.71,2,7.23,1.7,11.09a33.12,33.12,0,0,0,5.26,20.51c2.45,3.75,5.84,7.58,5.22,12s-5.23,7.41-7.68,11.33-2.65,9.16-1.94,13.88,2.18,9.32,2.56,14.07a6.34,6.34,0,0,1-.36,3.23A8.75,8.75,0,0,1,662,236.8a18.07,18.07,0,0,0-3.85,4.87,12.08,12.08,0,0,1-1.95,3.09,7.49,7.49,0,0,1-2.36,1.43c-6.29,2.65-13.55,2.18-20.06.09s-12.41-5.66-18.24-9.21a14.91,14.91,0,0,1-4.27-3.38,12.2,12.2,0,0,1-2.06-6.9c-.27-5.26.73-10.56.1-15.79-.66-5.45-3.05-10.52-4.56-15.8a49.62,49.62,0,0,1,1.18-30.56c1.49-4,3.61-8,7-10.57,7.33-5.58,18-3.33,26.46-6.91C645.7,144.49,653.67,142.39,659.53,148.13Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#ffd865",
    opacity: 0.35
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M589.31,812.18c6.59,3.73,22.87.92,33-1.38a6.13,6.13,0,0,0,3.74-9.42l-2.75-4.07-1.06-.16.94,0,10.32-44.27c6-20,2.66-35.28,0-47.26-1.27-5.73,1.72-18.46,5.18-30.18,5.72,2.48,11.37,4.36,16.12,4.89,2.94.33,6.18.65,9.57.9,3.64,9.57,6.8,18,7.07,19.07,4.29,17.16,25.29,25.29,25.29,25.29l53.58,60.91s-3.33,8.65-10,11.32c0,0-16.64,4-6,8,7.11,2.67,22.83-2.68,32.49-6.53a6.09,6.09,0,0,0,2.19-9.81l-3.39-3.63h-.31l-16.67-35.63c-2-10-20.63-37.94-32-43.27-6.6-3.1-12.28-17.51-15.89-29a30.65,30.65,0,0,0,13.22-8.95c12.65-15.31,18-6.66,42.6-12.65,31.24-7.6,19.24-29,15.57-29.09-16.67-7.64-60-47.68-64.46-51.78.83-.42,1.29-.68,1.29-.68l-1.6.39-.06-.06a58.31,58.31,0,0,0-2.92-8.72,61,61,0,0,0,6.47,4.88c7.75,5.06,17.48,8.39,26.28,5.51l-.21-.23c.51-.13,1-.27,1.54-.43a34.9,34.9,0,0,1-9.05-20.47,40.51,40.51,0,0,0,12.27-4.15c15.25-7.34,26.23-23.82,25.65-40.89-.22-6.52-1.9-13.14-.39-19.48,1.41-5.88,2.83-8.25,3.93-14.19,3.33-18,6.66-14.64,3.66-28.14-1.54-6.93-9.73-10.43-13.39-16.51-5.35-8.89-5.52-19.81-7-30.09s-5.16-21.47-14.36-26.26c-13.12-6.84-22.23-23.52-35.33-21.53-.7.11-1.4.19-2.09.26a29.24,29.24,0,0,0-16.29-3.63c-3.35.25-6.65,1.08-10,1.06a20,20,0,0,1-10.39-3c-.16.39-.29.79-.41,1.19-.31-.17-.62-.34-.92-.53a16,16,0,0,0-1,7.09A25.94,25.94,0,0,0,650,365c-.75-5.36-1.19-8.77-1.19-8.77l-1.33-65.9s15.31-26,.67-26-14,23.3-14,23.3l-4,50.59c-2.66,18,0,30,0,30,6.89,18.21,10.87,45.16,12.48,58-20.19,15.28-25.82,28.8-25.6,40-.25,11.51,5.77,20.72,9.13,27.14.82,1.56,1.2,4.84,1.23,9.44-.25,38-21.53,154.65-21.53,154.65l.22.09-.22,1.24,1.11.46c-1.27,4-2.65,8-4.11,11.86-7.32,19.3,0,32.62,0,32.62l6.9,91.61-.57-.09s-5.76,8.42-12.75,10C596.47,805.22,579.41,806.58,589.31,812.18Zm95.51-276.84-.06-.06a39,39,0,0,1-9.92-25.67,47.87,47.87,0,0,1,4.6-19.59A176,176,0,0,0,684,464a119.88,119.88,0,0,1,.21,14.48C683.41,497.54,679.89,517,684.83,535.34Z",
    transform: "translate(-131.37 -44.87)",
    fill: "url(#7be86fb0-21fd-45a4-8a23-e3ab7af79f8b-114)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M677.86,438.71c5.74,9.71,4.7,27.46-3.27,59.92,0,0-9.11,24.73,9.11,45.55s22.12,39,22.12,39,57.2,35.44,64.42,51.4c-10.74-23.75,24.52,10.25-16.27,20.17-24.07,5.86-29.28-2.6-41.64,12.36s-40.34,13-57.91,11.06-47.5-22.77-47.5-22.77,33.18-139.89,26-153.56c-6.77-12.93-31.12-37.5,16.58-69.32C659,426.22,672,428.88,677.86,438.71Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#f0898b"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M677.86,438.71c5.74,9.71,4.7,27.46-3.27,59.92,0,0-9.11,24.73,9.11,45.55s22.12,39,22.12,39,57.57,35.28,64.42,51.4c-10.09-23.75,24.52,10.25-16.27,20.17-24.07,5.86-29.28-2.6-41.64,12.36s-40.34,13-57.91,11.06-47.5-22.77-47.5-22.77,33.18-139.89,26-153.56c-6.77-12.93-31.12-37.5,16.58-69.32C659,426.22,672,428.88,677.86,438.71Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#ffdf9c"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M677.86,438.71c5.74,9.71,4.7,27.46-3.27,59.92,0,0-9.11,24.73,9.11,45.55s22.12,39,22.12,39,57.57,35.28,64.42,51.4c-10.09-23.75,24.52,10.25-16.27,20.17-24.07,5.86-29.28-2.6-41.64,12.36s-40.34,13-57.91,11.06-47.5-22.77-47.5-22.77,33.18-139.89,26-153.56c-6.77-12.93-31.12-37.5,16.58-69.32C659,426.22,672,428.88,677.86,438.71Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.03
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M695.42,661.29s8.46,37.74,19.52,42.94,29.28,32.53,31.23,42.29L762.76,782h-15l-52.38-59.54s-20.53-8-24.73-24.73c-.65-2.6-18.22-48.15-18.22-48.15Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#fec2be"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M646.62,649.58s-15.62,41.64-13,53.36,5.86,26.68,0,46.2L623.52,792.4l-13-.65L603.68,701s-7.16-13,0-31.88S616,626.81,616,626.81Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#fec2be"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M643.37,436.81s-3.9-39.69-13-63.77c0,0-2.6-11.71,0-29.28l3.9-49.45s-.65-22.77,13.66-22.77-.65,25.38-.65,25.38l1.3,64.42s8.46,65.72,14.31,72.88Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#fec2be"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M643.37,436.81s-3.9-39.69-13-63.77c0,0-2.6-11.71,0-29.28l3.9-49.45s-.65-22.77,13.66-22.77-.65,25.38-.65,25.38l1.3,64.42s8.46,65.72,14.31,72.88Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.05
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M646.62,390s2.6,31.23-5.21,41.64c0,0,18.22-9.76,33.83-1.3,0,0-9.76-26.68-6.51-38.39Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#fec2be"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M677.86,430.9c5.74,9.71,8.61,27.46.64,59.92,0,0-13,24.73,5.21,45.55s22.12,39,22.12,39,48.15,44.9,64.42,51.4c0,0,7.81,14.31-16.27,20.17s-29.28-2.6-41.64,12.36-40.34,13-57.91,11.06-47.82-14.64-47.82-14.64,27-148,19.85-161.69c-6.77-12.93-24.61-37.5,23.08-69.32C659,418.41,672,421.07,677.86,430.9Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#ffdf9c"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 526.96,
    cy: 401.7,
    r: 22.12,
    fill: "#fec2be"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M666.14,455.68,670.69,524l-15,72.88s13.66,48.15,0,43.59-14.31-44.25-14.31-44.25l9.11-76.13s-11.06-57.26-9.11-69S666.14,455.68,666.14,455.68Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.1
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M666.14,454.38l4.55,68.32-15,72.88s13.66,48.15,0,43.59-14.31-44.25-14.31-44.25l9.11-76.13s-11.06-57.26-9.11-69S666.14,454.38,666.14,454.38Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#fec2be"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M669.07,411.11c-9.21,0-17.59-2.63-22-10-.06-5.75-.41-9.88-.41-9.88l22.12,2c-1.4,5-.63,9.32,1,16.59C669.31,409.83,669.48,411.11,669.07,411.11Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.03
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 537.37,
    cy: 341.84,
    r: 25.38,
    fill: "#fec2be"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M641.09,484.64s-2,9.76-14.64,10.74",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.03
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M708.43,659.34c12.36-15,17.57-6.51,41.64-12.36s16.27-20.17,16.27-20.17c-16.27-6.51-64.42-51.4-64.42-51.4s-3.9-18.22-22.12-39-5.21-45.55-5.21-45.55c8-32.45,5.11-50.21-.64-59.92a19.56,19.56,0,0,0-15.07-9.49,19.72,19.72,0,0,1,19,9.49c5.74,9.71,8.61,27.46.64,59.92,0,0-13,24.73,5.21,45.55s22.12,39,22.12,39,48.15,44.9,64.42,51.4c0,0,7.81,14.31-16.27,20.17s-29.28-2.6-41.64,12.36c-8.55,10.35-24.56,12.61-39.44,12.37C686.6,671.49,700.63,668.79,708.43,659.34Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.03
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M659.53,416.15c.82-1.82,2.57-3,3.89-4.51,4.29-4.87,3.55-12.17,3.8-18.66a50.84,50.84,0,0,1,4.09-18,15.28,15.28,0,0,1-4.13-3,16.2,16.2,0,0,1-3.33-16.85A19.55,19.55,0,0,0,674,358c3.28,0,6.51-.79,9.79-1a28.59,28.59,0,0,1,15.93,3.55c.68-.07,1.36-.15,2-.26,12.81-1.94,21.71,14.37,34.53,21.05,9,4.69,12.63,15.63,14,25.67s1.58,20.72,6.8,29.41c3.58,5.94,11.59,9.37,13.09,16.14,2.93,13.2-.32,9.94-3.57,27.51-1.08,5.81-2.47,8.13-3.84,13.87-1.48,6.2.16,12.67.38,19,.71,20.92-16.34,40.95-37.11,43.58A34.11,34.11,0,0,0,735,577c-8.6,2.82-18.11-.44-25.69-5.39A61.55,61.55,0,0,1,684,537.13c-5.11-18.14-1.59-37.42-.78-56.25s-2.16-39.77-16.48-52C662.7,425.44,657.38,420.94,659.53,416.15Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.1
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M660.83,415.5c.82-1.82,2.57-3,3.89-4.51,4.29-4.87,3.55-12.17,3.8-18.66a50.84,50.84,0,0,1,4.09-18,15.28,15.28,0,0,1-4.13-3,16.2,16.2,0,0,1-3.33-16.85,19.55,19.55,0,0,0,10.16,2.94c3.28,0,6.51-.79,9.79-1A28.59,28.59,0,0,1,701,359.9c.68-.07,1.36-.15,2-.26,12.81-1.94,21.71,14.37,34.53,21.05,9,4.69,12.63,15.63,14,25.67s1.58,20.72,6.8,29.41c3.58,5.94,11.59,9.37,13.09,16.14,2.93,13.2-.32,9.94-3.57,27.51-1.08,5.81-2.47,8.13-3.84,13.87-1.48,6.2.16,12.67.38,19,.71,20.92-16.34,40.95-37.11,43.58a34.11,34.11,0,0,0,8.89,20.46c-8.6,2.82-18.11-.44-25.69-5.39a61.55,61.55,0,0,1-25.35-34.51c-5.11-18.14-1.59-37.42-.78-56.25s-2.16-39.77-16.48-52C664,424.79,658.68,420.29,660.83,415.5Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#af637c"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M747.8,782s-3.25,8.46-9.76,11.06c0,0-16.27,3.9-5.86,7.81,7,2.61,22.31-2.62,31.76-6.38a6,6,0,0,0,2.14-9.59l-3.31-3.55Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#4c4981"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M609.86,790.45s-5.63,8.23-12.46,9.79c0,0-16.68,1.33-7,6.8,6.44,3.64,22.36.9,32.28-1.35a6,6,0,0,0,3.65-9.21l-2.69-4Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#4c4981"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M707.46,575.08s-15,8.46-31.88,7.81",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.03
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M789.12,814.64c-2.33-2.17-4.52-4.73-5.2-7.84s.65-6.85,3.63-8c3.33-1.28,6.9,1,9.6,3.37s5.8,5,9.33,4.5a14.21,14.21,0,0,1-4.39-13.3,5.56,5.56,0,0,1,1.22-2.7c1.85-2,5.21-1.13,7.42.43,7,5,9,14.53,9.05,23.15.71-3.11.11-6.35.13-9.54s.89-6.72,3.58-8.44A10.79,10.79,0,0,1,829,795c3.17-.12,6.7.2,8.86,2.52,2.69,2.88,2,7.71-.35,10.88s-5.9,5.16-9.17,7.35a20.34,20.34,0,0,0-6.55,6.25,6.19,6.19,0,0,0-.49,1.12H801.4A55.36,55.36,0,0,1,789.12,814.64Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M971.2,657.65s74.33,54.11-76.56,114.45c0,0-26.73-61.9,12.67-107.07a47.66,47.66,0,0,1,62.77-8.16Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M970.38,656.57s-71.57,45.54-75.74,115.52",
    transform: "translate(-131.37 -44.87)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M893.1,764s24.67-83.76-4.63-145.41c-12.3-25.87-16.38-54.92-10.7-83a222.5,222.5,0,0,1,11.75-39",
    transform: "translate(-131.37 -44.87)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M871.29,457.7c0,10.27,18.59,40,18.59,40s18.59-29.77,18.59-40a18.59,18.59,0,0,0-37.17,0Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M840.57,514.56c5.58,8.62,37.36,23.5,37.36,23.5s-.58-35.09-6.16-43.71a18.59,18.59,0,0,0-31.2,20.2Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M841.91,611.73c9.17,4.62,44.11,1.43,44.11,1.43s-18.21-30-27.38-34.62a18.59,18.59,0,0,0-16.74,33.19Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M859.48,685c8.25,6.1,43.24,8.86,43.24,8.86s-12.88-32.64-21.13-38.75A18.59,18.59,0,1,0,859.48,685Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M917,540.05c-7.36,7.15-41.67,14.56-41.67,14.56s8.4-34.07,15.76-41.23A18.59,18.59,0,1,1,917,540.05Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M936.42,626c-9.17,4.62-44.11,1.43-44.11,1.43s18.21-30,27.38-34.62A18.59,18.59,0,1,1,936.42,626Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M943.87,712.18c-8.25,6.1-43.24,8.86-43.24,8.86s12.88-32.64,21.13-38.75a18.59,18.59,0,0,1,22.11,29.89Z",
    transform: "translate(-131.37 -44.87)",
    fill: "#25c725"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M871.29,457.7c0,10.27,18.59,40,18.59,40s18.59-29.77,18.59-40a18.59,18.59,0,0,0-37.17,0Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.25
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M840.57,514.56c5.58,8.62,37.36,23.5,37.36,23.5s-.58-35.09-6.16-43.71a18.59,18.59,0,0,0-31.2,20.2Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.25
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M841.91,611.73c9.17,4.62,44.11,1.43,44.11,1.43s-18.21-30-27.38-34.62a18.59,18.59,0,0,0-16.74,33.19Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.25
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M859.48,685c8.25,6.1,43.24,8.86,43.24,8.86s-12.88-32.64-21.13-38.75A18.59,18.59,0,1,0,859.48,685Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.25
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M917,540.05c-7.36,7.15-41.67,14.56-41.67,14.56s8.4-34.07,15.76-41.23A18.59,18.59,0,1,1,917,540.05Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.25
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M936.42,626c-9.17,4.62-44.11,1.43-44.11,1.43s18.21-30,27.38-34.62A18.59,18.59,0,1,1,936.42,626Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.25
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M943.87,712.18c-8.25,6.1-43.24,8.86-43.24,8.86s12.88-32.64,21.13-38.75a18.59,18.59,0,0,1,22.11,29.89Z",
    transform: "translate(-131.37 -44.87)",
    opacity: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishImage);
export default __webpack_public_path__ + "static/media/wish-image.787f5f8418632528a89b402f796115b9.svg";
export { ForwardRef as ReactComponent };